import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import { LoadingBar } from 'quasar';

@Module({name: 'FileUpload', namespaced: true})
export default class FileUpload extends VuexModule {
    public fileUploadProgress: any = null;

    @Mutation
    public RESET_FILE_UPLOAD_STORE_STATE() {
        this.fileUploadProgress = null;
    }

    get getFileUploadProgress(): any {
        return this.fileUploadProgress;
    }

    get getFileIsUploading(): boolean {
        return this.fileUploadProgress !== null;
    }

    @Action
    public UPLOAD_FILE(data: any) {
        store.commit(Mutations.INIT_FILE_UPLOAD_PROGRESS, {localFileIndex: data.fileIndex, progress: 0});

        return axios({
            method: data.method,
            url: data.endpoint,
            data: data.file,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent: ProgressEvent) => {
                LoadingBar.increment();
                store.commit(Mutations.SET_FILE_UPLOAD_PROGRESS, Math.round((progressEvent.loaded * 100) / progressEvent.total));
            },
        })
            .then((response: any) => {
                store.commit(Mutations.RESET_FILE_UPLOAD_PROGRESS);
            })
            .catch((error) => {
                store.commit(Mutations.RESET_FILE_UPLOAD_PROGRESS);

                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public INIT_FILE_UPLOAD_PROGRESS(fileProgress: any) {
        this.fileUploadProgress = fileProgress;
    }

    @Mutation
    public SET_FILE_UPLOAD_PROGRESS(progress: any) {
        this.fileUploadProgress.progress = progress;
    }

    @Mutation
    public RESET_FILE_UPLOAD_PROGRESS() {
        this.fileUploadProgress = null;
    }
}
